export enum NewsStatus {
  Published = "published",
  Draft = "draft",
}

export enum NewsStatusLabel {
  Published = "Објављено",
  Draft = "Радна верзија",
}
